import { FaWhatsapp } from "react-icons/fa";
import { useEffect } from "react";
import { useLocation } from "react-router";

const TermsAndCondition = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <>
            <div>
                {/* navbar      */}
                <div className="bg-gray-50 p-5 shadow-lg flex justify-between items-center">
                    <div>
                        <h1 className="text-4xl font-bold">MyReading</h1>
                    </div>
                    <div className="flex items-center space-x-2">

                        <p className="text-lg font-bold">+91 9309140606</p>
                        <a
                            href="https://wa.me/919309140606"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp className="cursor-pointer hover:scale-110 text-green-500" size={24} />
                        </a>
                    </div>
                </div>
                {/* all textual content  */}
                <div className="flex flex-col justify-center p-5 max-w-5xl mx-auto">
                    <h1 className="text-2xl text-gray-800 font-bold mb-2">Terms of Service</h1>
                    <p className="mb-3">Welcome to MyReading, our Library Management Software. By using our service, you agree to the following terms:</p>
                    <div className="p-4">
                        <ul className="list-disc space-y-4 p-3">
                            <li>
                                <span className="font-bold">Subscription Plans:</span> MyReading is a paid service with three subscription plans based on features and requirements. Each plan provides different levels of access and functionality to library owners.
                            </li>
                            <li>
                                <span className="font-bold">Plan Upgrade Policy:</span> Once a plan is purchased, it cannot be upgraded or downgraded during the subscription cycle. Upgrades can only be done after the completion of the current subscription period.
                            </li>
                            <li>
                                <span className="font-bold">Feature Access:</span> Users subscribed to basic plans may not have access to advanced features like seat reservations or detailed analytics. Feature availability depends strictly on the plan chosen.
                            </li>
                            <li>
                                <span className="font-bold">Authorized Use Only:</span> Only valid users can use MyReading. If an account is found to be violating our policies or involved in fraudulent activity, access will be denied.
                            </li>
                            <li>
                                <span className="font-bold">Trial Period:</span> We offer a 7 days free trial to allow users to explore the software's features. After the trial period, a subscription must be purchased to continue using MyReading.
                            </li>
                            <li>
                                <span className="font-bold">No Refund Policy:</span> Once a plan has been purchased, no refunds will be issued under any circumstances. Users are encouraged to use the trial period to assess their needs before purchasing.
                            </li>
                            <li>
                                <span className="font-bold">Data Responsibility:</span> All member data is uploaded and managed by the library owner. MyReading does not verify or modify this data and is not responsible for any errors or misunderstandings.
                            </li>
                            <li>
                                <span className="font-bold">Technical Support:</span> MyReading is responsible for resolving technical issues such as slow website performance or downtime. We ensure that the platform remains accessible and functional at all times.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsAndCondition;
